import React from 'react';
import { Button, Drawer } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import {
  ColumnSettingsType,
  FormServFieldType,
  RuleType,
} from '../../../shared/types';
import EditColumnsForm from './EditColumnsForm';

type EditColumnsButtonProps = {
  fields?: FormServFieldType[];
  columnOrder?: string[];
  columnSettings?: ColumnSettingsType;
  hiddenColumns?: string[];
  valuePath?: string;
  rule?: RuleType;
  setColumnOrder?: (columnIds: string[]) => void;
  setHiddenColumns?: (columnIds: string[]) => void;
};

const EditColumnsButton = (props: EditColumnsButtonProps) => {
  const { t } = useTranslation();
  const {
    fields,
    setColumnOrder,
    setHiddenColumns,
    columnSettings,
    valuePath,
    columnOrder,
    rule,
    hiddenColumns,
  } = props;
  const [isEditColumnDrawerOpen, toggleEditColumnDrawer] =
    React.useState<boolean>(false);
  React.useEffect(() => {
    if (!setHiddenColumns || !rule || !rule?.condition_sets?.length) return;
    const neededColumns: string[] = [];
    rule?.condition_sets.forEach((condition_set) => {
      if (condition_set?.conditions.length)
        condition_set.conditions.forEach((condition) => {
          if (condition.name) neededColumns.push(condition.name);
        });
    });
    let newColumnOrder: string[] = [...(columnOrder || [])];
    const newHiddenColumns: string[] = (hiddenColumns || []).filter((hC) => {
      const doFilter = !neededColumns.includes(hC);
      if (!doFilter) {
        newColumnOrder = [...newColumnOrder.filter((cO) => cO !== hC), hC];
      }
      return doFilter;
    });
    if (setColumnOrder) setColumnOrder(newColumnOrder);
    setHiddenColumns(newHiddenColumns);
  }, [rule]);
  return (
    <>
      <Button
        id="edit-column-btn"
        type="secondary"
        inline
        onClick={() => toggleEditColumnDrawer(true)}
      >
        {t('contacts.edit_column_drawer.title')}
      </Button>
      <Drawer
        isOpen={isEditColumnDrawerOpen}
        onDismiss={() => toggleEditColumnDrawer(false)}
        isFullHeight
        size="medium"
        clickOutToClose={false}
        placement="right"
      >
        <EditColumnsForm
          fields={fields}
          columnSettings={columnSettings}
          columnOrder={columnOrder}
          valuePath={valuePath}
          setColumnOrder={setColumnOrder}
          hiddenColumns={hiddenColumns}
          setHiddenColumns={setHiddenColumns}
          toggleDrawer={(flag: boolean) => toggleEditColumnDrawer(flag)}
        />
      </Drawer>
    </>
  );
};

export default EditColumnsButton;
